"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSettings = {
    announcementsDivId: "announcements",
    primaryFocusTarget: "main h1, [role=main] h1",
    documentTitle: () => new Promise(resolve => setTimeout(() => resolve(document.title))),
    // TODO i18n
    documentTitleAnnounceFallback: "new page",
    // TODO i18n
    navigationMessage: (title) => `Navigated to ${title}.`,
    shouldHandleAction: () => true,
    disableAutoScrollRestoration: true,
    announcePageNavigation: true,
    setPageTitle: false,
    handleHashFragment: true,
    restorePageStateOnPop: true,
    renderTimeout: 0,
    defaultPageState: { x: 0, y: 0 },
    smoothScroll: undefined,
    setMessageTimeout: undefined,
    clearMessageTimeout: undefined,
};
